import { getAvailableInterestList } from '@pages/Root/pages/HomeRoot/utils.ts';
import { getInterestUIDByURLName } from '@pages/Root/utils';
import {
  INTEREST_SCHEDULE,
  LATEST_SCHEDULE,
  LATEST_TITLE,
} from '@pages/Root/pages/HomeRoot/constants.ts';
import {
  API_URL,
  DEFAULT_CKEY,
  getInitializedMomentFetcher,
} from '@moment/net/fetch-contstants.ts';
import { IDailyLookBookResponce } from '@pages/Root/services/api/lookBook/lookbook-model-definitions.ts';
import { QueryClient } from '@tanstack/react-query';
import { IInterestData } from '@pages/Root/services/api/interest/interest-model-definitions.ts';
import { INTEREST_QUERY_KEY } from '@moment/net/classic-fotoscapes/fetch-interests.ts';
import { resolvedLanguage } from '@/i18n.ts';

// NEW: Define granular query keys for the lookbooks of a single interest/schedule.
export const INTEREST_LOOKBOOKS_QUERY_KEYS = {
  schedule: (scheduleId: string) => ['interest-lookbooks', scheduleId],
};

// This function is already the perfect atomic unit for fetching. We will reuse it.
export const fetchScheduleItems = async (
  language: string,
  schedule: string
) => {
  const momentFetcher = await getInitializedMomentFetcher();
  const url = `${API_URL}/wp/v1/daily?ckey=${DEFAULT_CKEY}&sched=${schedule}&mp_lang=${language}&previewAspect=all`;
  const rawResponse = await momentFetcher.fetch(url);
  const response = (await rawResponse.json()) as IDailyLookBookResponce;
  return response.items.filter((item) => item.lbtype === 'standard');
};


export const genFetchInterestQuery = (params:any) => {
  const interests = params.interests
  const language = params?.lang || resolvedLanguage('en');
  if (!interests) {
    console.warn(
      'Interests data not found in queryClient during category pre-fetch. Cannot generate queries.'
    );
  }
  const { interestTitle } = params
  if (!interestTitle) return [];

  const interestUID = getInterestUIDByURLName(interestTitle);
  const availableInterestList = getAvailableInterestList(
    interests.mapped,
    interestUID
  ).sort(({ uid }) => (uid === interestUID ? -1 : 1));

  const queryDefinitions = [];


  if (interestTitle === LATEST_TITLE) {
    queryDefinitions.push({
      interestUid: 'Latest',
      queryKey: INTEREST_LOOKBOOKS_QUERY_KEYS.schedule(LATEST_SCHEDULE),
      queryFn: () => () => fetchScheduleItems(language, LATEST_SCHEDULE),
    });
  }

  for (const interest of availableInterestList) {
    const schedule = INTEREST_SCHEDULE[interest.uid];
    if (schedule) {
      queryDefinitions.push({
        interestUid: interest.uid,
        queryKey: INTEREST_LOOKBOOKS_QUERY_KEYS.schedule(schedule),
        // The queryFn is the actual async function, not a factory.
        queryFn: () => () => fetchScheduleItems(language, schedule),
      });
    }
  }

  return queryDefinitions;
}
